import * as d3 from 'd3';

export const formatNumber = d3.format(',d');
export const formatNumberSignificant = d3.format('.3~s');
export const formatWithCustomGigaBillion = (value) => {
  const formattedValue = formatNumberSignificant(value);
  const formattedWithBillion = formattedValue.replace('G', 'B');
  return formattedWithBillion;
};